<template>
	<div class="placement-selector-container">
		<!-- uncomment this when we want to enable openDetails button -->
		<!-- <ListSelector
			:items="placements"
			v-bind="$attrs"
			v-on="$listeners"
			v-if="showListSelector"
			allowKeyboardNavigation
			:show-end-hover-area-key="'id'"
			@end-hover-section-clicked="openDetails"
		> -->
		<template v-if="showListSelector">
			<ListSelector v-bind="$attrs" :items="filteredPlacements" pk="pk" @selectItem="selectPlacement" allowKeyboardNavigation returnObject>
				<template #item-content="{ item: { element_type: elementType, ...placement } }">
					<slot name="item-content" v-bind:item="{ element_type: elementType, ...placement }">
						<PlacementRow :placement="placement" :elementType="elementType" />
					</slot>
				</template>
				<template #tooltip>
					<ExtensionNeededTooltip />
				</template>
				<template #end-hover="{ item }">
					<DetailsButton @click.stop="openDetails(item.id)" />
				</template>
			</ListSelector>
			<template v-if="generalFilteredPlacements.length > 0">
				<span class="general-context-text">General contexts that work in {{ serviceName }}</span>
				<ListSelector
					class="mt-2"
					v-bind="$attrs"
					:items="generalFilteredPlacements"
					@selectItem="selectPlacement"
					allowKeyboardNavigation
					returnObject
				>
					<template #item-content="{ item: { element_type: elementType, ...placement } }">
						<PlacementRow :placement="placement" :elementType="elementType" />
					</template>
					<template #tooltip>
						<ExtensionNeededTooltip />
					</template>
					<template #end-hover="{ item }">
						<DetailsButton @click.stop="openDetails(item.id)" />
					</template>
				</ListSelector>
			</template>
		</template>
		<div v-else class="display-flex flex-wrap">
			<div>
				<ListItemShield class="selected-item display-flex flex-column">
					<div class="flex-1 display-flex flex-column">
						<PlacementRow :placement="selectedPlacement" :elementType="selectedElementType" class="flex-1" />
					</div>
				</ListItemShield>
			</div>
			<div class="flex-centerize pl-4">
				<h5 class="change-button text-underline" role="button" @click="selectPlacement({ id: null, element_type: null })">Change</h5>
			</div>
		</div>
	</div>
</template>

<script>
import PlacementRow from './PlacementRow.vue';
import DetailsButton from './DetailsButton.vue';
import ExtensionNeededTooltip from './ExtensionNeededTooltip.vue';
import ListItemShield from '@/components/common/ListSelector/ListItemShield.vue';
import ListSelector from '@/components/common/ListSelector/ListSelector.vue';
import { UIElementType } from '@ply-io/ply-front-shared-utilities';
import ContextService from '@/utils/ContextService';
export default {
	name: 'PlacementSelector',
	props: {
		placements: { type: Array },
		contextsOfPlacements: { type: Array },
		generalPlacements: { type: Array, default: () => [] },
		selectedPlacement: { type: Object },
		selectedElementType: { type: String },
		serviceName: { type: String },
		tilesAreActive: { type: Boolean },
		useSingletonPlacements: { type: Boolean },
	},
	components: { PlacementRow, ListSelector, DetailsButton, ListItemShield, ExtensionNeededTooltip },
	methods: {
		openDetails(appId) {
			console.log('openDetails', appId);
		},
		selectPlacement({ id: placementId, element_type: elementType }) {
			this.$emit('selectPlacement', { placementId, elementType });
		},
		filterPlacementsForElementType(placements) {
			return this.selectedElementType ? placements.filter((p) => p.element_type === this.selectedElementType) : placements;
		},
	},
	computed: {
		showListSelector() {
			return !this.selectedPlacement;
		},
		singletonPlacements() {
			return Object.values(
				this.placements.reduce((singletonPlacements, placement) => {
					const context = this.contextsOfPlacements?.find((context) => context.id === placement.version.context);
					if (context && ContextService.isSingleton(context) && !(context.id in singletonPlacements)) {
						singletonPlacements[context.id] = { ...placement, item_name: context.title, item_name_prefix: '', item_name_suffix: '' };
					}
					return singletonPlacements;
				}, {})
			);
		},
		enrichedPlacements() {
			const enrichedPlacements = this.placements.map((p) => ({ ...p, element_type: UIElementType.Button }));
			if (this.useSingletonPlacements) {
				enrichedPlacements.push(
					...this.singletonPlacements.map((p) => ({ ...p, element_type: UIElementType.Tile, disabled: p.disabled || !this.tilesAreActive }))
				);
			}
			return enrichedPlacements.map((p) => ({ ...p, pk: `${p.id}-${p.element_type}` }));
		},
		generalTilePlacements() {
			return this.generalPlacements.map((p) => ({ ...p, element_type: UIElementType.Tile, disabled: p.disabled || !this.tilesAreActive }));
		},
		filteredPlacements() {
			return this.filterPlacementsForElementType(this.enrichedPlacements);
		},
		generalFilteredPlacements() {
			return this.filterPlacementsForElementType(this.generalTilePlacements);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/styles/utility-classes/backgrounds.scss';
.placement-selector-container {
	max-height: 410px;
	overflow-y: auto;
	overflow-x: hidden;
	h5.change-button {
		font-size: 10px;
	}
	.selected-item {
		@extend .hover-background;
	}
	.general-context-text {
		font-size: 12px;
	}
}
</style>
